module.exports = __webpack_public_path__ + "static/media/PolinaSlide.3ba6a889.jpg";